
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import ErrorBoundary from "./components/layout/ErrorBoundary.tsx";
import { ProductionOptimizer } from "./components/production/ProductionOptimizer.tsx";
import "./styles/index.css";

// Performance monitoring
if (process.env.NODE_ENV === 'development') {
  // Enable React DevTools performance profiling
  if (typeof window !== 'undefined') {
    (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__?.onCommitFiberRoot;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ProductionOptimizer />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
